import React from 'react';
import PropTypes from 'prop-types';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router';
import RootStoreContext from '~/contexts/RootStoreContext';
import { actions as agentScannersActions } from '~/domains/agentScanners';
import AgentScannersViewContainer from './components/AgentScannersView/AgentScannersView.container';
import ScanConfigurationsListContainer from './components/ScanConfigurationsList/ScanConfigurationsList.container';

const AgentScannersList = ({ organizationId, dispatch, route }) => {
  const history = useHistory();
  const match = useRouteMatch();

  const handleScanConfigurationClick = (scanConfig, options = {}) => {
    if (options.action === 'update') {
      return;
    }

    const basePath = match.url.endsWith('/') ? match.url : `${match.url}/`;
    const targetPath = `${basePath}${scanConfig.id}/`;

    history.push(targetPath);
  };

  const handleAddScanner = (scannerData) => {
    return dispatch(
      agentScannersActions.createAgentScanner(organizationId, scannerData)
    );
  };

  const handleUpdateScanner = (scannerData) => {
    return dispatch(
      agentScannersActions.updateAgentScanner(
        organizationId,
        scannerData.id,
        scannerData
      )
    );
  };

  // Navigate back to scanner list (called after form submit/cancel)
  const handleFormClose = () => {
    const basePath = match.url.replace(/\/add\/?$/, '/');

    history.push(basePath);
  };

  return (
    <AgentScannersViewContainer
      route={route}
      onScanConfigurationClick={handleScanConfigurationClick}
      onAddScanner={handleAddScanner}
      onUpdateScanner={handleUpdateScanner}
      onFormClose={handleFormClose}
      getPath={() => ''}
      ScanConfigurationsListComponent={ScanConfigurationsListContainer}
    />
  );
};

AgentScannersList.propTypes = {
  organizationId: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  route: PropTypes.shape({
    isAdd: PropTypes.bool,
    isEdit: PropTypes.bool
  })
};

const mapStateToProps = (state) => ({
  organizationId: state.session?.profile?.organization?.id || ''
});

export default compose(
  withRouter,
  connect(mapStateToProps, null, null, {
    context: RootStoreContext
  })
)(AgentScannersList);
